import React, { useEffect, useState } from "react";
import { CaretIcon, ModalCloseButton, Select } from "react-responsive-select";
import "react-responsive-select/dist/react-responsive-select.css";

//Textfield
interface TextfieldProps {
  title: string;
  value: string;
  isEditable: boolean;
  isSecretField?: boolean;
  onSend?: (value: string) => void;
  onChange: (value: string) => void;
}

const Textfield: React.FC<TextfieldProps> = ({
  title,
  value,
  isEditable,
  isSecretField,
  onSend,
  onChange,
}) => {
  const [currentValue, setCurrentValue] = useState(value);

  useEffect(() => {
    setCurrentValue(value);
    if (onSend) {
      onSend(value);
    }
  }, [value]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setCurrentValue(e.target.value);
    onChange(e.target.value);
  };

  return (
    <div className="w-60 h-20 relative ml-5">
      <div
        className={`left-0 top-0 absolute text-center text-black text-x2 font-semibold font-['Open Sans'] leading-3`}
      >
        {title}
      </div>
      <div
        className={`w-60 h-10 left-0 top-[21px] absolute rounded-md border border-[#EEEEEE]`}
        style={{ outline: "none" }}
      >
        {isEditable ? (
          !isSecretField ? (
            <input
              className="w-full h-full absolute text-[#757575] text-x3 font-semibold font-['Open Sans'] ml-5"
              value={currentValue}
              onChange={handleChange}
              style={{ outline: "none" }}
            />
          ) : (
            <input
              type="password"
              className="w-full h-full absolute text-[#757575] text-x3 font-semibold font-['Open Sans']"
              value={currentValue}
              onChange={handleChange}
              style={{ outline: "none" }}
            />
          )
        ) : (
          <div className="left-[11px] top-[10px] absolute text-center text-[#757575] text-x3 font-semibold font-['Open Sans'] leading-3">
            {currentValue}
          </div>
        )}
      </div>
    </div>
  );
};

export default Textfield;
//endTextfield

//Split schoolClass function
export function parseSchoolClass(schoolClass: string) {
  if (!schoolClass || !schoolClass.includes("_")) {
    console.log(
      'Invalid input! The input string must contain a "_" character.',
    );
    const level = "";
    const serie = "";
    return { level, serie };
  }
  let [level, serie] = schoolClass.split("_");
  level = level.charAt(0).toUpperCase() + level.slice(1).toLowerCase();
  return { level, serie };
}
//end Split schoolClass function

//getInitials function
export function getInitials(str1: string, str2: string): string {
  let lettre1 = str1.charAt(0).toUpperCase();
  let lettre2 = str2.charAt(0).toUpperCase();
  return lettre1 + lettre2;
}
//end getInitials function

//SelectField
const TextfieldChoising: React.FC = () => {
  const [currentValue, setCurrentValue] = useState("");

  return (
    <div className="flex flex-col h-screen w-full relative bg-[#FCFCFC] justify-center space-y-10 rounded-lg border border-slate-50">
      <form>
        <Select
          name="carType1"
          modalCloseButton={<ModalCloseButton />}
          options={[
            { value: "null", text: "Any" },
            { value: "subaru", text: "Subaru" },
          ]}
          caretIcon={<CaretIcon />}
          prefix="Car1: "
          selectedValue="subaru"
          onChange={(newValue) => console.log("onChange", newValue)}
          onSubmit={() => console.log("onSubmit")}
        />
      </form>
    </div>
  );
};
